<template>
    <div>
      <div>
        <div class="margin-top-s">
          <p>Todos os dados de exportação por questão de <b>SEGURANÇA</b> serão enviados para o e-mail de criação da conta: <b>{{ account.email }}</b></p>
        </div>
        <div class="margin-top-l">
          <section>
            <h3>Vendas</h3>
          </section>
          <section class="grid-flex wrap">
            <div class="item flex-1 box flex middle center" @click="openModalReport('sale')" >
              <div class="box-content">
                  <p>
                    <b>Todas as Vendas</b>
                  </p>
              </div>
            </div>
            <div class="item flex-1 box flex middle center" @click="openModalReport('sale-30')">
              <div class="box-content">
                  <p>
                    <b>Dos Últimos 30 dias</b>
                  </p>
              </div>
            </div>
          </section>
        </div>

        <div class=" margin-top-l">
          <section>
            <h3>Marketing</h3>
          </section>
          <section class="grid-flex wrap">
            <div class="item flex-1 box flex middle center" @click="openModalReport('marketing')">
                <div class="box-content">
                    <p>
                      <b>Todos os dados de Marketing</b>
                    </p>
                </div>
            </div>

            <div class="item flex-1 box flex middle center" @click="openModalReport('marketing-30')">
                <div class="box-content">
                    <p>
                      <b>Dos Últimos 30 dias</b>
                    </p>
                </div>
            </div>
          </section>
        </div>

        <div class=" margin-top-l">
          <section>
            <h3>Utms</h3>
          </section>
          <section class="grid-flex wrap">
            <div class="item flex-1 box flex middle center" @click="openModalReport('utm')">
                <div class="box-content">
                    <p>
                      <b>Todos os dados de Utms</b>
                    </p>
                </div>
            </div>

            <div class="item flex-1 box flex middle center" @click="openModalReport('utm-30')">
                <div class="box-content">
                    <p>
                      <b>Dos Últimos 30 dias</b>
                    </p>
                </div>
            </div>
          </section>
        </div>

        <div class=" margin-top-l">
          <section>
            <h3>Leads</h3>
          </section>
          <section class="grid-flex wrap">
            <div class="item flex-1 box flex middle center" @click="openModalReport('lead')">
              <div class="box-content">
                  <p>
                    <b>Todos os dados dos Leads</b>
                  </p>
              </div>
            </div>
            <div class="item flex-1 box flex middle center" @click="openModalReport('lead-30')">
              <div class="box-content" >
                  <p>
                    <b>Dos Últimos 30 dias</b>
                  </p>
              </div>
            </div>
          </section>
        </div>
  
        <section class="flex center-txt margin-top-l">
          <p>
            Gostaria de outro tipo de informação? Entre em contato que podemos adicionar:
            <a href="mailto:contato@unicotracker.com.br"
              >contato@unicotracker.com.br</a
            >
          </p>
        </section>
      </div>

      <!-- modal confirm delete -->
      <modal-confirm
        :show="showModalExport"
        description="Você tem certeza que deseja exportar os dados?"
        @cancel="
          showModalExport = false;
          selectedReport = null;
        "
        @accept="createExportData(selectedReport)"
      ></modal-confirm>
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";

  import ModalConfirm from "@/components/modal/ModalConfirm";

  import { createExportData } from "@/services/export";
  
  export default {
    name: "export",
    components: {
      ModalConfirm
    },
    props: ["slug"],
    data() {
      return {
        loading: false,
        selectedReport: null,
        showModalExport: false,
      };
    },
    mounted() {},
    computed: {
      ...mapState({
        user: (state) => state.user,
        account: (state) => state.account,
      }),
    },
    methods: {
      openModalReport(report) {
        this.showModalExport = true
        this.selectedReport = report
      },
      createExportData(report) {
        this.showModalExport = false
        this.selectedReport = null
        
        let params = {
          'report': report
        }
        createExportData(params)
          .then(() => {
            this.$toast.success({
              title:'Sucesso',
              message:'Solicitação de exportação criada com sucesso. Em breve você vai receber no e-mail'
            })
          })
          .catch(() => {
            this.$toast.error({
              title:'Erro',
              message:'Ocorreu algum problema'
            })
          })

      },
      checkResource(name) {
        return this.account && this.account.resources.includes(name);
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .box {
    min-width: 300px;
    min-height: 130px;
    margin-top: 16px;
    margin-left: 0px !important;
    margin-right: 20px;

    cursor: pointer;
  
    .box-content {
      cursor: pointer;
    }
  
    a {
      width: 100%;
      height: 100%;
    }
  }
  
  .disabled-box {
    background: #e8e8e8;
    > a {
      cursor: none;
    }
  }
  
  .tag {
    background: var(--primary);
    color: #fff;
    padding: 4px 12px;
    border-radius: 40px;
    font-size: 10px;
    font-weight: 600;
  }
  </style>
  